import { useState } from "react";


import { Loader } from "../../components/utilities/loader";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { useAuth } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utilities/alert";
import {  userHNDSubscription } from "../../services/documents/documents.context";



export const ActivateHNDUser = () => {

    const { token } = useAuth();

    const [onErr, setOnErr] = useState(false);

    const [email, setEmail] = useState('');

    const [loading, setLoading] = useState(false);
    const [valError, setValError] = useState({
        caption: null,
        message: null
    });

    const isNull = (v) => (v === "" || v === undefined || v === null);

    const inputRequired = () => {
        return  isNull(email) ;
    }

    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={`Subscribe past question user`} />
            {(loading) && <Loader />}
            {onErr && 
                <AppAlert 
                    caption={valError.caption}
                    message={valError.message}
                    close={() => setOnErr(false)}
                    accept={"Ok"}
                    acceptAction={() => {
                        setValError(null);
                        setOnErr(false);
                    }}
                />
            }
            <div className="form-container">
                
                <div className="input-container">
                    <span className="input-cap">
                        User email
                        <span className="req-asterix">*</span>
                    </span>
                    <input 
                        type="email" 
                        className="input"
                        placeholder="Email used by user to subscribe to this app" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                
                <button 
                    className="form-button"
                    onClick={ async (e) => {
                        e.preventDefault();
                        if (inputRequired()) {
                            setOnErr(true);
                            setValError((err) => (
                                {
                                    ...err, 
                                    caption: "Error!",
                                    message: "Please provide all the required data"
                                }
                            ))
                            return;
                        }else{
                            setOnErr(false);
                            setValError((err) => ({...err, caption: null, message: null}));
                        }
                        setLoading(true);
                        const msg = await userHNDSubscription(token, email);
                        setLoading(false);
                        setValError({
                            caption: "Message",
                            message: msg?.message
                        })
                        setOnErr(true);
                        setEmail('')
                    }}
                >
                   Subscribe user
                </button>
            </div>
        </div>
    );
}